/* eslint-disable */

// import external dependencies
import 'jquery';
import 'slick-carousel/slick/slick.min';

// Import everything from autoload
;

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import blog from './routes/archive';
import templateContactPage from './routes/template-contacts-page';
import archiveProjectsData from './routes/archive-projects-data'

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  //Contact Page
  templateContactPage,
  //Archive,
  blog,

  archiveProjectsData
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());


// WEBPACK FOOTER //
// ./scripts/main.js